import { persons as kycAcceptance } from '@repo/api-kit/kyc-acceptance';
import type { KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';

const { ApiKycCurrentStatus, ApiProcessStatus, ApiProcessType } = kycAcceptance.firstparty.v1;

export function createAcceptedKycResponse() {
  return {
    kycCurrentStatus: ApiKycCurrentStatus.accepted,
    activeProcess: null,
  };
}

export function createRefusedKycResponse() {
  return {
    kycCurrentStatus: ApiKycCurrentStatus.refused,
    activeProcess: null,
  };
}

export function createPendingNoProcessKycResponse(): KycResponse {
  return {
    kycCurrentStatus: ApiKycCurrentStatus.pending,
    activeProcess: null,
  };
}

export function createReKycResponse(dueDate?: Date | null): KycResponse {
  return {
    kycCurrentStatus: ApiKycCurrentStatus.accepted,
    activeProcess: {
      type: ApiProcessType.re_kyc,
      processStatus: ApiProcessStatus.PROCESS_STATUS_UNSPECIFIED,
      dueDate: dueDate ?? null,
      provider: null,
      providerDetails: null,
      signatureRequired: false,
    },
  };
}

// Represents a user whose account is restricted or suspended because the re-kyc deadline has passed
export function createReKycPastDueResponse(): KycResponse {
  return {
    kycCurrentStatus: ApiKycCurrentStatus.pending,
    activeProcess: {
      type: ApiProcessType.re_kyc,
      processStatus: ApiProcessStatus.PROCESS_STATUS_UNSPECIFIED,
      dueDate: null,
      provider: null,
      providerDetails: null,
      signatureRequired: false,
    },
  };
}

export function createKycResponseWithoutProvider(): KycResponse {
  return {
    kycCurrentStatus: ApiKycCurrentStatus.pending,
    activeProcess: {
      processStatus: ApiProcessStatus.pending_personal_info,
      providerDetails: null,
      provider: null,
      signatureRequired: false,
      type: ApiProcessType.initial,
    },
  };
}

export * from './idnow';
export * from './fourthline';
